import { Icon } from '@chakra-ui/react';

export const CloseIcon = (props) => (
  <Icon viewBox="0 0 22 18" {...props}>
    <path d="M1.26074 17.4941C0.884766 17.1289 0.895508 16.5059 1.26074 16.1406L8.13574 9.25488L1.26074 2.37988C0.895508 2.01465 0.895508 1.40234 1.26074 1.02637C1.62598 0.639648 2.25977 0.650391 2.625 1.02637L9.5 7.90137L16.375 1.02637C16.7402 0.650391 17.3633 0.650391 17.7393 1.02637C18.1152 1.3916 18.1045 2.01465 17.7393 2.37988L10.8643 9.25488L17.7393 16.1406C18.1045 16.5059 18.1045 17.1182 17.7393 17.4941C17.374 17.8701 16.7402 17.8594 16.375 17.4941L9.5 10.6191L2.625 17.4941C2.25977 17.8594 1.63672 17.8594 1.26074 17.4941Z" fill="white"/>  
  </Icon>
);
